import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChatInputService {
  private suggestions = signal<Record<string, string[]>>({});
  private chatInputs = signal<Record<string, string>>({});

  getSuggestions(tabId: string | undefined): string[] {
    if (!tabId) return [];
    return this.suggestions()[tabId] || [];
  }

  setSuggestions(tabId: string | undefined, suggestions: string[]) {
    if (!tabId) return;
    this.suggestions.update((currentSuggestions) => ({
      ...currentSuggestions,
      [tabId]: suggestions,
    }));
  }

  clearSuggestions(tabId: string | undefined) {
    if (!tabId) return;
    this.setSuggestions(tabId, []);
  }

  getChatInput(tabId: string | undefined): string {
    if (!tabId) return '';
    return this.chatInputs()[tabId] || '';
  }

  setChatInput(tabId: string | undefined, input: string) {
    if (!tabId) return;
    this.chatInputs.update((current) => ({
      ...current,
      [tabId]: input,
    }));
  }

  clearChatInput(tabId: string | undefined) {
    if (!tabId) return;
    this.chatInputs.update((current) => {
      const updated = { ...current };
      delete updated[tabId];
      return updated;
    });
  }
}